/* src/app/shared/components/shared-modal/shared-modal.component.scss */
.modal-dialog {
  display: flex;
  align-items: center;
  margin: auto 4px;
}
@media (max-width: 767px) {
  .modal-dialog {
    height: 90dvh;
    width: 90dvw;
    display: flex;
    flex-direction: column;
  }
  .modal-dialog .modal-content {
    overflow: hidden;
  }
  .modal-dialog .modal-content .modal-header .close {
    margin: -0.5rem 0 0 auto;
  }
  .modal-dialog .modal-content .modal-body {
    overflow-y: auto;
    overflow-x: hidden;
  }
  .modal-dialog .modal-content .modal-footer {
    display: flex !important;
    justify-content: space-between;
  }
  .modal-dialog .modal-content .modal-footer .btn + .btn {
    margin-left: auto;
  }
}
/*# sourceMappingURL=shared-modal.component.css.map */
